module.exports = __webpack_public_path__ + "img/base_activites_paddle.8350d163.svg";